import { Box, Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import parse from 'html-react-parser';
import Image from 'next/image';
import styled from 'styled-components';
import type { BulletsLayoutValue } from '../index';
import type { TrustBulletItemProps } from '../types';

const BulletTitle = styled.span`
  text-wrap: balance;
  display: block;
  ${font('main', { fontSize: '2.0rem', lineHeight: 1.3, fontWeight: 700 })};
  @media (max-width: 400px) {
    white-space: pre-line;
  }
`;

const BulletText = styled.span<{
  color?: string;
}>`
  text-wrap: pretty;
  display: block;
  color: ${({ color }) => color};
  ${font('main', { fontSize: '1.6rem', lineHeight: '2.2rem' })};
  margin-top: 5px;
`;

const BulletContainer = styled(Flex).attrs<{ layout: BulletsLayoutValue }>(() => ({
  as: 'li',
}))`
  text-align: center;
  ${MEDIA_QUERIES.tabletAndDesktop`
    text-align: ${({ layout }) => (layout === 'horizontal' ? 'center' : 'left')};
  `}
`;

interface TrustBulletProps {
  readonly bullet: TrustBulletItemProps;
  readonly bulletsLayout: `${BulletsLayoutValue}`;
}

export const TrustBullet: React.FC<TrustBulletProps> = ({
  bullet: { image, text, textColor = '#4A4A4A', title, name },
  bulletsLayout,
}) => {
  return (
    <BulletContainer
      flex="1"
      tabIndex={0}
      margin="0 auto"
      alignItems="center"
      justifyContent="center"
      gap="18px"
      maxWidth="600px"
      layout={bulletsLayout}
      flexDirection={bulletsLayout === 'vertical' ? ['column', 'row'] : 'column'}
    >
      <Image aria-hidden={true} src={image.src} alt={title} width={image.width} height={image.height} loading="lazy" />
      <Box width="100%">
        <BulletTitle data-edit-for={`title-${name}`}>{parse(title)}</BulletTitle>
        <BulletText color={textColor} data-edit-for={`text-${name}`}>
          {parse(text)}
        </BulletText>
      </Box>
    </BulletContainer>
  );
};
